// extracted by mini-css-extract-plugin
export default {"spinner":"ContentModal_spinner__oGpe8"};